(function () {
  // Offer selection
  var offers = document.querySelectorAll('.rb-offer');
  var input = document.getElementById('rb-variant');
  var atc = document.getElementById('rb-atc');
  offers.forEach(function (o) {
    o.addEventListener('click', function () {
      if (o.disabled) return;
      offers.forEach(function (x) { x.classList.remove('is-on'); x.setAttribute('aria-checked', 'false'); });
      o.classList.add('is-on'); o.setAttribute('aria-checked', 'true');
      if (input) input.value = o.getAttribute('data-variant');
      var price = o.getAttribute('data-price');
      document.querySelectorAll('[data-rb-price]').forEach(function (el) { el.textContent = price; });
      if (atc) atc.disabled = false;
    });
  });
  // Gallery thumbs
  var track = document.getElementById('rb-track');
  var thumbs = document.querySelectorAll('.rb-thumb');
  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      var i = parseInt(t.getAttribute('data-slide'), 10) || 0;
      if (track) track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
      thumbs.forEach(function (x) { x.classList.remove('is-on'); }); t.classList.add('is-on');
    });
  });
  if (track) track.addEventListener('scroll', function () {
    var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
    thumbs.forEach(function (x, k) { x.classList.toggle('is-on', k === i); });
  }, { passive: true });
  // Smooth scroll to offers
  document.querySelectorAll('a[href="#offers"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var t = document.getElementById('offers');
      if (!t) return;
      e.preventDefault();
      window.scrollTo({ top: t.getBoundingClientRect().top + window.scrollY - 90, behavior: 'smooth' });
    });
  });
  // Mobile sticky bar: visible once the offers are off screen
  var sticky = document.getElementById('rb-sticky');
  var anchor = document.getElementById('rb-form');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (en) {
      var e = en[0];
      sticky.hidden = e.isIntersecting || e.boundingClientRect.top > 0;
    }).observe(anchor);
  }
})();
